<div [ngClass]="['mybets-scoreboard_stats', getClass()]">
    <div class="mybets-scoreboard_stats-values mybets-scoreboard_stats-values-set">
        @if (vm().points?.isVisible) {
            <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-turn" [ngClass]="vm().turn.statClasses">
                <div class="cell highlight" [ngClass]="{ 'serving-dot': vm().turn.player1 }"></div>
                <div class="cell highlight" [ngClass]="{ 'serving-dot': vm().turn.player2 }"></div>
                <div class="cell"></div>
            </div>
            <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-points" [ngClass]="vm().points?.statClasses">
                <div class="cell highlight bold">{{ vm().points?.player1 }}</div>
                <div class="cell highlight bold">{{ vm().points?.player2 }}</div>
                <div class="cell"></div>
            </div>
        }

        @for (stat of vm().sets.list; track stat) {
            <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-set" [ngClass]="stat.statClasses">
                @if (stat.isVisible) {
                    <div class="cell" [ngClass]="{ highlight: vm().isHighlighedSet($index, 1) }">{{ stat.isEmpty(1) ? '-' : stat.player1 }}</div>
                    <div class="cell" [ngClass]="{ highlight: vm().isHighlighedSet($index, 2) }">{{ stat.isEmpty(2) ? '-' : stat.player2 }}</div>
                    <div class="cell"></div>
                }
            </div>
        }
    </div>
</div>
